export default __webpack_public_path__ + "static/media/contactAnimation.0fe1f604.svg";